// コメント位置はPrettier対策
class AppCertification {
  //FIXME 本番設定に書き換えてください。
  /**
   * アプリケーションの定数値です。
   */
  APPVERSION = "26.07.01";
  APP_CONFIG = {
    //FIXME MockModeの有効無効
    // HttpClientのgetを対象として、dummy.jsonを読み込むフラグです。
    MOCK_MODE: false,

    /**
     * API接続用設定（VDI外アクセス）
     */
    // ローカル環境
    //BASE_URL: "http://localhost:8080/",
    // 本番環境
    BASE_URL: "https://cirrus-tm-noki.nikkon.jp/",
    //本番環境（検証用ドメイン）
    //BASE_URL: "https://pr.noki.nikkon-is.com/",
  };

  /**
   * Cognitoの設定です。
   */
  //FIXME 納期回答用設定に書き換えてください。
  //営業所用
  COGNITO = {
    USER_POOL_ID: "ap-northeast-1_xrVE0R1f9",
    APP_CLIENT_ID: "5u0eps4slel448al4lagd9jkfd",
  };

  //荷主用
  SHIPPER_COGNITO = {
    USER_POOL_ID: "ap-northeast-1_VhNgDeknx",
    APP_CLIENT_ID: "2e674jstbj5va1tiifgc5a9ub9",
  };

  /** datadog */
  DATADOG = {
    DD_APPLICATION_ID: "f5dbf4a7-ef77-4572-9829-ade93e2b6c3e",
    DD_CLIENT_TOKEN: "pubf4878a93b267ad4433faf5fa86204eba",
    DD_SERVICE: "nr-pr-pc",
    DD_ENV: "nr-pr",
    DD_SESSION: 20,
  };
  /** datadog */
}

export const appCertification = new AppCertification();
